import BasicType from 'src/entities/basic-types/BasicType';

export const CUSTOM_FIELD_HIDDEN_SERIAL_NUMBER: string = 'HIDDEN_SERIAL_NUMBER';
export const CUSTOM_FIELD_HIDDEN_APPLIANCE_ID: string = 'HIDDEN_APPLIANCE_ID';

export const HIDDEN_CUSTOM_FIELDS = [CUSTOM_FIELD_HIDDEN_SERIAL_NUMBER, CUSTOM_FIELD_HIDDEN_APPLIANCE_ID];

export default class CustomField extends BasicType {
    fieldName: string;
    localizedName: string;
    defaultValue?: string;
    options?: Record<string, string>;

    constructor(fieldName: string, localizedName: string, options?: Record<string, string>) {
        super();

        this.fieldName = fieldName;
        this.localizedName = localizedName;
        this.options = options;
    }

    public static fromJson(json: any): CustomField {
        return new CustomField(json.fieldName, json.localizedName, json.options);
    }

    public toString(): string {
        return this.localizedName;
    }

    public get hidden(): boolean {
        return HIDDEN_CUSTOM_FIELDS.includes(this.fieldName);
    }
}
